import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';

const CreatDirecteur = () => {
  const [directeurData, setDirecteurData] = useState({
    observation: '',
    du: '',
    au: '',
    personnelId: null,
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);

  // Fonction pour gérer les changements dans le formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDirecteurData({ ...directeurData, [name]: value });
  };

  // Fonction pour gérer la recherche des personnels
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Rechercher les personnels si la recherche n'est pas vide
    if (value) {
      axios
        .get(`personnel?nomprenom=${value}`)
        .then((response) => {
          setPersonnelSuggestions(response.data.slice(0, 10)); // Limiter à 10 suggestions
        })
        .catch((error) => {
          toast.success('Erreur lors de la recherche des personnels', error);
        });
    } else {
      setPersonnelSuggestions([]);
    }
  };

  // Fonction pour gérer la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/directeurs', directeurData);
      toast.success('Directeur créé avec succès !');
      // Réinitialiser le formulaire après la création
      setDirecteurData({ observation: '', du: '', au: '', personnelId: null });
      setSearchTerm(''); // Réinitialiser le champ de recherche
      setPersonnelSuggestions([]); // Effacer les suggestions
    } catch (error) {
      toast.warn('Erreur lors de la création du directeur !');
    }
  };

  // Fonction pour sélectionner un personnel
  const handleSelectPersonnel = (personnel) => {
    setDirecteurData({ ...directeurData, personnelId: personnel.id });
    setSearchTerm(personnel.nomprenom); // Remplir le champ avec le nom sélectionné
    setPersonnelSuggestions([]); // Effacer les suggestions
  };

  return (
    <div className="container mt-5">
      <h1>Ajouter un Directeur</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Observation</label>
          <input type="text" name="observation" className="form-control" value={directeurData.observation} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Du</label>
          <input type="text" name="du" className="form-control" value={directeurData.du} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Au</label>
          <input type="text" name="au" className="form-control" value={directeurData.au} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Recherche Personnel</label>
          <input type="text" className="form-control" value={searchTerm} onChange={handleSearchChange} placeholder="Tapez pour chercher..." />
          {personnelSuggestions.length > 0 && (
            <ul className="list-group mt-2">
              {personnelSuggestions.map((personnel) => (
                <li key={personnel.id} className="list-group-item list-group-item-action" onClick={() => handleSelectPersonnel(personnel)}>
                  {personnel.nomprenom}
                </li>
              ))}
            </ul>
          )}
        </div>
        <button type="submit" className="btn btn-primary">
          Créer Directeur
        </button>
      </form>
    </div>
  );
};

export default CreatDirecteur;
